<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-mesagerie">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-brands fa-rocketchat"></i>
                                <span>Mesagerie</span>
                            </mat-card-title>
                        </div>

                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onMessagingChange($event)" value="internalMsg">
                                    <!-- <mat-button-toggle value="toCetatean">Către Cetățean</mat-button-toggle> -->
                                    <mat-button-toggle value="internalMsg">Mesaj Intern</mat-button-toggle>
                                    <mat-button-toggle value="nota">Notă</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="row p-2" *ngIf="selectedMessagingToggle == 'toCetatean'">
                        <div class="col">
                            <div class="fw-bold">Transmiteți către cetățean un mesaj</div>
                        </div>
                    </div>
                    <div class="row p-2" *ngIf="selectedMessagingToggle == 'internalMsg'">
                        <div class="col">
                            <div class="fw-bold">Adăugați un mesaj</div>
                        </div>
                    </div>
                    <div class="row p-2" *ngIf="selectedMessagingToggle == 'nota'">
                        <div class="col">
                            <div class="fw-bold">Adăugați o notă</div>
                        </div>
                    </div>

                    <form [formGroup]="sendMessageCetateanForm" (ngSubmit)="submitMessage('cetatean')"
                        *ngIf="selectedMessagingToggle == 'toCetatean'">
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="sendMessageCetateanForm.get('message')?.touched &&sendMessageCetateanForm.get('message')?.invalid">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="solicitare-card__upload mx-2 mt-3">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Fotografii/Documente</p>
                                <button class="upload-btn" (click)="fileInputCetatean.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>
                            <div class="solicitare-card__upload-files"
                                *ngIf="sendMessageCetateanForm.value.files.length > 0 && !uploading.file">
                                <div class="solicitare-card__upload-file" *ngFor="
                                    let uploadedFile of sendMessageCetateanForm.value.files;
                                    let i = index
                                ">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ uploadedFile.original_name.length > 30? (uploadedFile.original_name
                                        | slice : 0 : 30) + ".." : uploadedFile.original_name
                                        }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFileCetatean(i)">
                                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading.file"></mat-spinner>

                            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                id="upload-file-input-0" #fileInputCetatean name="fileInputCetatean"
                                (change)="addFileCetatean($event, 'file')" multiple style="display: none" />
                        </div>

                        <!-- <div class="row my-3">
                            <div class="col d-flex align-items-center">
                                <mat-checkbox style="margin-right: 30px" formControlName="notify" color="primary">Notificare
                                    răspuns
                                </mat-checkbox>
                                <form [formGroup]="notifyAnswer" style="width: 30%">
                                    <ng-container *ngIf="sendMessageCetateanForm.get('notify')?.value">
                                        <mat-form-field class="mt-3">
                                            <mat-label>Număr zile</mat-label>
                                            <mat-select formControlName="notify_date_expire">
                                                <mat-option *ngFor="let response of responseTimes" [value]="response.value">
                                                    {{ response.key }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="
                                                notifyAnswer.get('notify_date_expire').touched &&
                                                notifyAnswer
                                                    .get('notify_date_expire')
                                                    .hasError('required')
                                            ">
                                                Câmp obligatoriu
                                            </mat-error>
                                        </mat-form-field>
                                    </ng-container>
                                </form>
                            </div>
                        </div> -->

                        <div class="col d-flex justify-content-between">
                            <button class="btn btn-light upload-btn m-3" type="button" (click)="openSabloane()">
                                <span class="upload__text">Șabloane</span>
                            </button>

                            <button class="btn btn-light upload-btn m-3" type="submit"
                                [disabled]="sendMessageCetateanForm.invalid">
                                <span class="upload__text">TRIMITE</span>
                            </button>
                        </div>
                    </form>

                    <form [formGroup]="sendMessageInternForm" (ngSubmit)="submitMessage('intern')"
                        *ngIf="selectedMessagingToggle == 'internalMsg'">
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="sendMessageInternForm.get('message')?.touched && sendMessageInternForm.get('message')?.invalid">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="row p-1">
                            <div class="col">
                                <mat-form-field class="w-100">
                                    <mat-label>Adaugă coleg</mat-label>
                                    <mat-chip-grid #chipGrid aria-label="Selectare colegi">
                                        <mat-chip-row *ngFor="let coleague of coleagues"
                                            (removed)="removeColeague(coleague)">
                                            {{ coleague.name }}
                                            <button matChipRemove [attr.aria-label]="'remove ' + coleague.name">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    </mat-chip-grid>
                                    <input placeholder="Coleg nou..." #coleagueInput [formControl]="coleaguesCtrl"
                                        [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        (matChipInputTokenEnd)="addColeague($event)" />
                                    <mat-autocomplete #auto="matAutocomplete"
                                        (optionSelected)="selectedColeagues($event)">
                                        <mat-option *ngFor="let coleague of filteredColeagues | async"
                                            [value]="coleague">
                                            {{ coleague.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="solicitare-card__upload mx-2">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Fotografii/Documente</p>
                                <button class="upload-btn" (click)="fileInputIntern.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>
                            <div class="solicitare-card__upload-files"
                                *ngIf="sendMessageInternForm.value.files && sendMessageInternForm.value.files.length > 0 && !uploading.file">
                                <div class="solicitare-card__upload-file" *ngFor="
                                        let uploadedFile of sendMessageInternForm.value.files;
                                        let i = index
                                    ">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                        | slice : 0 : 30) + ".." : uploadedFile.original_name
                                        }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFileIntern(i)">
                                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading.file"></mat-spinner>

                            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                id="upload-file-input-0" #fileInputIntern name="fileInputIntern"
                                (change)="addFileIntern($event, 'file')" multiple style="display: none" />
                        </div>

                        <div class="col d-flex justify-content-end">
                            <button class="btn btn-light upload-btn m-3" type="submit"
                                [disabled]="sendMessageInternForm.invalid">
                                <span class="upload__text">TRIMITE</span>
                            </button>
                        </div>
                    </form>

                    <form [formGroup]="sendMessageNotitaForm" (ngSubmit)="submitMessage('nota')"
                        *ngIf="selectedMessagingToggle == 'nota'">
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="sendMessageNotitaForm.get('message')?.touched && sendMessageNotitaForm.get('message')?.invalid">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="solicitare-card__upload mx-2 mt-3">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Fotografii/Documente</p>
                                <button class="upload-btn" (click)="fileInputNotita.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>
                            <div class="solicitare-card__upload-files" *ngIf="
                                sendMessageNotitaForm.value.files.length > 0 &&
                                !uploading.file
                                ">
                                <div class="solicitare-card__upload-file" *ngFor="
                                    let uploadedFile of sendMessageNotitaForm.value.files;
                                    let i = index
                                ">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                        | slice : 0 : 30) + ".." : uploadedFile.original_name
                                        }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFileNota(i)">
                                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading.file"></mat-spinner>

                            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                id="upload-file-input-0" #fileInputNotita name="fileInputNotita"
                                (change)="addFileNotita($event, 'file')" multiple style="display: none" />
                        </div>

                        <div class="col d-flex justify-content-end">
                            <button class="btn btn-light upload-btn m-3" type="submit"
                                [disabled]="sendMessageNotitaForm.invalid">
                                <span class="upload__text">TRIMITE</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>